import createIcon from '../../createIcon';

/**
 * @component @name CommentsDisabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNDg0NyAxMy4zNDUySDE4LjY1NDdWMTEuMzQ1MkgxNS40ODQ3TDE0LjQ4NDcgMTAuMzQ1MkgxOC42NTQ3VjguMzQ1MjFIMTIuNDg0N0wxMS40ODQ3IDcuMzQ1MjFIMTguNjU0N1Y1LjM0NTIxSDkuNDg0NzNMNS40ODQ3MyAxLjM0NTIxSDIwLjY1NDdDMjEuNzU0NyAxLjM0NTIxIDIyLjY1NDcgMi4yNDUyMSAyMi42NTQ3IDMuMzQ1MjFWMTguNTE1MkwxNy40ODQ3IDEzLjM0NTJaTTIuNzU0NzMgMS40NDUyMUwxLjM0NDczIDIuODU1MjFMMi42NTQ3MyA0LjE3NTIxVjE1LjM0NTJDMi42NTQ3MyAxNi40NDUyIDMuNTU0NzMgMTcuMzQ1MiA0LjY1NDczIDE3LjM0NTJIMTUuODI0N0wyMS4xMzQ3IDIyLjY1NTJMMjIuNTQ0NyAyMS4yNDUyTDIuNzU0NzMgMS40NDUyMVpNNi42NTQ3MyA4LjM0NTIxSDYuODI0NzNMOC44MjQ3MyAxMC4zNDUySDYuNjU0NzNWOC4zNDUyMVpNNi42NTQ3MyAxMy4zNDUyVjExLjM0NTJIOS44MjQ3M0wxMS44MjQ3IDEzLjM0NTJINi42NTQ3M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CommentsDisabled = createIcon('CommentsDisabled', [
  [
    'path',
    {
      d: 'M17.4847 13.3452H18.6547V11.3452H15.4847L14.4847 10.3452H18.6547V8.34521H12.4847L11.4847 7.34521H18.6547V5.34521H9.48473L5.48473 1.34521H20.6547C21.7547 1.34521 22.6547 2.24521 22.6547 3.34521V18.5152L17.4847 13.3452ZM2.75473 1.44521L1.34473 2.85521L2.65473 4.17521V15.3452C2.65473 16.4452 3.55473 17.3452 4.65473 17.3452H15.8247L21.1347 22.6552L22.5447 21.2452L2.75473 1.44521ZM6.65473 8.34521H6.82473L8.82473 10.3452H6.65473V8.34521ZM6.65473 13.3452V11.3452H9.82473L11.8247 13.3452H6.65473Z',
      key: '109gqd',
    },
  ],
]);

export default CommentsDisabled;
